<template>
  <div>
    <el-dialog
      :title="title"
      :visible="isShowRefundDialog"
      width="30%"
      @close="handleDialog"
      @open="init"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">

        <el-form-item label="订单金额" prop="amount">
          {{ $formatter.FenToYuan(null, null, item.amount, null) }}
        </el-form-item>

        <el-form-item label="退款金额" prop="refundAmount">
          <el-input
            size="small"
            type="text"
            v-model="form.refundAmount"
          ></el-input>
        </el-form-item>

        <el-form-item label="扣减商户" prop="orderRefund">
              <el-col :span="12">
                <el-select
                  v-model="form.orderRefund"
                  placeholder="--请选择--"
                  size="small"
                >
                  <el-option label="是" value="01"></el-option>
                  <el-option label="否" value="00"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

        <el-form-item label="订单号" prop="orderId">
          {{item.orderId}}
        </el-form-item>

        <el-form-item label="appId" prop="appId">
          {{item.appId}}
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>

        <el-form-item label="通知邮箱" prop="contactInfo">
          <el-input
            size="small"
            type="text"
            v-model="item.contactInfo"
            autocomplete="off"
          ></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowRefundDialog: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    item: {
      type:Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: {
        toStatus: '',
        remark: '',
        amount: '',
        refundAmount: '',
        orderRefund: '',
        contactInfo: '',
      },
      title:'',
      rules: {
        refundAmount: [
            { required: true, message: '请输入退款金额', trigger: 'blur' },
          ],
          remark: [
            { required: true, message: '请输入备注', trigger: 'blur' },
          ],
          orderRefund: [
            { required: true, message: '请选择是否扣减商户余额', trigger: 'blur' },
          ],
        },
    }
  },
  methods: {
    init(){
      this.title='退款给付款人',
      this.form.refundAmount=this.$formatter.FenToYuan(
          null,
          null,
          this.item.amount,
          null
        )
    },
    handleDialog() {
      this.$refs['form'].resetFields()
      this.form = {
        orderId: '',
        remark: '',
        refundAmount: '',
        orderRefund:'',
        contactInfo:'',
      }
      this.$emit('update:isShowRefundDialog', false)
    },
    submit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          const params = {
            orderId: this.item.orderId,
            refundAmount: this.form.refundAmount,
            remark: this.form.remark,
            orderRefund: this.form.orderRefund,
            contactInfo: this.item.contactInfo,
          }

          this.$axios.get("/order/cash_refund", {params: params}).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: '提示',
                message: res.msg,
                type: 'success',
              })
              this.$emit('update:isShowRefundDialog', false)
              this.$bus.$emit('refresh') //通知刷新
              // this.$handleDialog()
            } else {
              this.$notify.error({
                title: '提示',
                message: res.msg,
              })
              // this.$emit('update:isShowRefundDialog', false)
              this.$bus.$emit('refresh') //通知刷新
            }
          }) 
        }
      })
    },
  },
}
</script>